import Styled from "styled-components";

export const Quantity = Styled.div`
 button {
  color: ${props => props.theme.whitelabel?.text_primary_color} !important;
  svg {
    color: ${props => props.theme.whitelabel?.text_primary_color} !important;
  }
 }

 span {
  color: ${props => props.theme.whitelabel?.text_primary_color} !important;
 }
`;